import {
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
import { Jsonsmkyu9xjl7fv as Json } from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { get_serializersStore3e4gm3fdgip9r as get_serializersStore } from './ktor-ktor-client-ktor-client-plugins-ktor-client-json.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(KotlinxSerializer, 'KotlinxSerializer', KotlinxSerializer);
initMetadataForObject(SerializerInitializer, 'SerializerInitializer');
//endregion
function KotlinxSerializer$Companion$DefaultJson$lambda($this$Json) {
  $this$Json.l60_1 = false;
  $this$Json.k60_1 = false;
  $this$Json.w60_1 = true;
  $this$Json.y60_1 = false;
  return Unit_instance;
}
function Companion() {
  Companion_instance = this;
  var tmp = this;
  tmp.z6a_1 = Json(VOID, KotlinxSerializer$Companion$DefaultJson$lambda);
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function KotlinxSerializer(json) {
  Companion_getInstance();
  json = json === VOID ? Companion_getInstance().z6a_1 : json;
  this.a6b_1 = json;
}
var initializer;
function SerializerInitializer() {
  SerializerInitializer_instance = this;
  var tmp0 = get_serializersStore();
  // Inline function 'kotlin.collections.plusAssign' call
  var element = new KotlinxSerializer();
  tmp0.e(element);
}
var SerializerInitializer_instance;
function SerializerInitializer_getInstance() {
  if (SerializerInitializer_instance == null)
    new SerializerInitializer();
  return SerializerInitializer_instance;
}
//region block: eager init
initializer = SerializerInitializer_getInstance();
//endregion

